import { fireEvent, RenderResult } from '@testing-library/react';

export const changeSelectValue = async (screen: RenderResult, classNamePrefix: string, newLabel: string) => {
  const placeholder = screen.container.querySelector(`.${classNamePrefix}__input`) as Element;
  fireEvent.keyDown(placeholder, {
    key: 'ArrowDown',
  });
  await screen.findByText(newLabel);
  fireEvent.click(screen.getByText(newLabel));
};
